import { shopliftTesting } from 'utils/shoplift-testing';

export default (element, data) => {
  const modalActivator = element.querySelector('[data-modal-activator]');
  const modal = element.querySelector('[data-modal]');
  // modal video
  const videoEl = element.querySelector('[data-component="video"].is_modal');
  const realReset = videoEl?.querySelector('[data-video-reset]')
  let videoTime = [0, 0];
  let videoTimeDesktop = [0, 0];
  if (!modalActivator || !modal) return;

  const stopPlayer = () => {
    realReset?.click()
  };

  const closeBtns = modal.querySelectorAll('[data-close]');
  const toggleModal = (e) => {
    const isModalHidden = modal.classList.contains('hidden');
    modal.classList.toggle('hidden');

    if (!e.target.dataset?.noBodyLock && !e.currentTarget.dataset?.noBodyLock) {
      document.body.style.overflow === 'hidden'
        ? (document.body.style.overflow = '')
        : (document.body.style.overflow = 'hidden');
    }
    const videos = videoEl.querySelectorAll('.fixed .mobile-video-container video');
    const videosDesktop = document.querySelectorAll('.desktop-hero-video >.relative video');
    if (!isModalHidden) {
      // if we want reset all video in modal to 0 we need to uncomment this
      // stopPlayer();
      videos.forEach((item, index) => {
        item.pause()
        videoTime[index] = item.currentTime;
      })

      videosDesktop.forEach((video, index) => {
        video.currentTime = videoTimeDesktop[index];
        video.play()
      })
    } else {
      videos.forEach((video, index) => {
        video.currentTime = videoTime[index];
        video.play()
      })
      videosDesktop.forEach((item, index) => {
        item.pause()
        videoTimeDesktop[index] = item.currentTime;
      })
    }
  };

  const closeByBackdrop = (e) => {
    if (e.target === e.currentTarget) {
      toggleModal(e);
    }
  };

  const subscribeToEvents = () => {
    modal.addEventListener('click', closeByBackdrop);
    modalActivator.addEventListener('click', toggleModal);
    closeBtns.forEach((closeBtn) => {
      closeBtn.addEventListener('click', toggleModal);
    });
  };

  const init = () => {
    shopliftTesting(element, data);
    subscribeToEvents();
  };
  init();
};
